import { createRicosFunctionalExtension } from 'wix-rich-content-plugin-commons';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const lineSpacing = createRicosFunctionalExtension({
  type: "extension",
  groups: [],
  name: "lineSpacing",
  reconfigure(config, extensions) {
    const types = extensions.filter((extension) => extension.groups.includes("text-container")).map(({ name }) => name);
    return __spreadProps(__spreadValues({}, config), {
      addGlobalAttributes() {
        return [
          {
            types,
            attributes: {
              textStyle: {
                renderHTML: (attributes) => {
                  var _a;
                  const styles = [];
                  if ((_a = attributes == null ? void 0 : attributes.textStyle) == null ? void 0 : _a.lineHeight) {
                    styles.push(`line-height:${attributes.textStyle.lineHeight}`);
                  }
                  return {
                    style: styles.join(";")
                  };
                }
              }
            }
          },
          {
            types,
            attributes: {
              style: {
                renderHTML: (attributes) => {
                  var _a, _b;
                  const styles = [];
                  if ((_a = attributes == null ? void 0 : attributes.style) == null ? void 0 : _a.paddingTop) {
                    styles.push(`padding-top:${attributes.style.paddingTop}`);
                  }
                  if ((_b = attributes == null ? void 0 : attributes.style) == null ? void 0 : _b.paddingBottom) {
                    styles.push(`padding-bottom:${attributes.style.paddingBottom}`);
                  }
                  return {
                    style: styles.join(";")
                  };
                }
              }
            }
          }
        ];
      },
      addCommands() {
        return {
          setLineSpacings: (lineSpacings) => ({ chain }) => {
            const {
              "line-height": stringLineHeight,
              "padding-bottom": stringPaddingBottom,
              "padding-top": stringPaddingTop
            } = lineSpacings;
            const lineHeight = parseFloat(stringLineHeight);
            const paddingBottom = parseFloat(stringPaddingBottom);
            const paddingTop = parseFloat(stringPaddingTop);
            return chain().focus().setLineSpacing(lineHeight).setLineSpacingBefore(paddingTop).setLineSpacingAfter(paddingBottom).run();
          },
          setLineSpacing: (lineSpacing2) => ({ commands }) => {
            if (lineSpacing2 > 100 || lineSpacing2 < 0) {
              return false;
            }
            return types.every(
              (type) => commands.updateAttributesWithDeepMerge(type, {
                textStyle: { lineHeight: lineSpacing2 }
              })
            );
          },
          setLineSpacingBefore: (lineSpacing2) => ({ commands }) => {
            if (lineSpacing2 > 100 || lineSpacing2 < 0) {
              return false;
            }
            return types.every(
              (type) => commands.updateAttributesWithDeepMerge(type, {
                style: {
                  paddingTop: `${lineSpacing2}px`
                }
              })
            );
          },
          setLineSpacingAfter: (lineSpacing2) => ({ commands }) => {
            if (lineSpacing2 > 100 || lineSpacing2 < 0) {
              return false;
            }
            return types.every(
              (type) => commands.updateAttributesWithDeepMerge(type, {
                style: {
                  paddingBottom: `${lineSpacing2}px`
                }
              })
            );
          }
        };
      }
    });
  },
  createExtensionConfig() {
    return {
      name: this.name
    };
  }
});

export { lineSpacing };
//# sourceMappingURL=tiptap.js.map
